export const PUBLIC_WEBSITE_ORIGIN = 'https://www.overtureai.org';

function cleanSlug(value?: string | null): string {
  return String(value || '').trim();
}

export function publicPartnerPageUrl(partnerSlug?: string | null): string {
  const slug = cleanSlug(partnerSlug);
  return slug ? `${PUBLIC_WEBSITE_ORIGIN}/partners/${slug}` : '';
}

export function publicLocationPageUrl(locationSlug?: string | null): string {
  const slug = cleanSlug(locationSlug);
  return slug ? `${PUBLIC_WEBSITE_ORIGIN}/schools/${slug}` : '';
}

export function isNonStripePaymentMode(paymentMode?: string | null): boolean {
  const mode = String(paymentMode || '').trim().toLowerCase();
  return mode === 'school_enrollment' || mode === 'school_flat_fee' || mode === 'external';
}

type PublicFlagEntity = {
  active?: boolean | null;
  isPublic?: boolean | null;
};

/**
 * Partners must opt in (`isPublic === true`). Locations inherit that flag
 * unless they are inactive or explicitly hidden (`isPublic === false`).
 */
export function isLocationVisibleOnWebsite(
  partner?: PublicFlagEntity | null,
  location?: PublicFlagEntity | null
): boolean {
  return Boolean(
    partner
    && location
    && partner.active !== false
    && location.active !== false
    && partner.isPublic === true
    && location.isPublic !== false
  );
}
